var React = require('react');

function Twitter (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M25.004 5.452c-.92.408-1.909.684-2.946.808a5.145 5.145 0 0 0 2.255-2.838 10.27 10.27 0 0 1-3.257 1.244 5.13 5.13 0 0 0-8.741 4.679A14.564 14.564 0 0 1 1.74 3.985a5.106 5.106 0 0 0-.695 2.58c0 1.78.906 3.35 2.282 4.27a5.109 5.109 0 0 1-2.323-.642v.064a5.133 5.133 0 0 0 4.114 5.03 5.14 5.14 0 0 1-2.316.088 5.135 5.135 0 0 0 4.792 3.563 10.292 10.292 0 0 1-6.371 2.196c-.414 0-.823-.025-1.224-.072a14.519 14.519 0 0 0 7.864 2.305c9.435 0 14.595-7.817 14.595-14.596 0-.222-.005-.444-.015-.664a10.422 10.422 0 0 0 2.56-2.655z"}));
}

Twitter.displayName = "Twitter";

Twitter.defaultProps = {"viewBox":"0 0 25 25"};

module.exports = Twitter;

Twitter.default = Twitter;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/twitter.svg
// module id = 1286
// module chunks = 0